import React from 'react';

export const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
    <path
      d="M8.906 15a6.1 6.1 0 01-6.092-6.094A6.101 6.101 0 018.906 2.81 6.102 6.102 0 0115 8.906 6.101 6.101 0 018.906 15zm0-15c.26 0 .469.21.469.469v3.3a5.167 5.167 0 014.667 4.668h3.302a.469.469 0 110 .938H14.04a5.166 5.166 0 01-4.666 4.666v3.303a.469.469 0 11-.938 0V14.04a5.166 5.166 0 01-4.665-4.666H.47a.469.469 0 110-.938h3.303a5.166 5.166 0 014.665-4.669v-3.3c0-.258.21-.468.47-.468z"
      fill="#74746D"
      fillRule="evenodd"
    />
  </svg>
);

export const DropIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5">
    <path
      d="M4.167 5L0 .769.757 0l3.41 3.463L7.577 0l.756.769z"
      fill="#74746D"
      fillRule="evenodd"
    />
  </svg>
);

export const DropOpenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5">
    <path
      d="M4.167 0L0 4.231.757 5l3.41-3.463L7.577 5l.756-.769z"
      fill="#74746D"
      fillRule="evenodd"
    />
  </svg>
);

export const HeavyDropDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6">
    <path
      d="M5 6L0 .922.908 0 5 4.155 9.092 0 10 .922z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export const HeavyDropDownIconOpen = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6">
    <path
      d="M5 0L0 5.078.908 6 5 1.845 9.092 6 10 5.078z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export const MapPinIcon = () => (
<svg width="10" height="10" viewBox="0 0 40 50">
    <g id="Developments" stroke="none" strokwidth="1" fill="none" fill-rule="evenodd">
        <g id="Developments-1.2-(Selected)" transform="translate(-1006.000000, -882.000000)" fill="currentColor">
            <g id="Map" transform="translate(847.000000, 172.000000)">
                <path d="M178.892007,710 C193.622507,710 203.165507,725.5605 196.734007,738.631 C193.622657,745.2695 183.247507,755.2285 178.892007,760 C174.327557,754.8125 164.577507,745.6855 161.257007,738.838 C154.411507,725.9745 163.954257,710 178.892007,710 Z M178.892007,717.469 C185.737507,717.469 191.339507,723.0705 191.339507,729.9165 C191.339507,736.762 185.738007,742.364 178.892007,742.364 C172.046007,742.364 166.444507,736.7625 166.444507,729.9165 C166.444507,723.071 172.046007,717.469 178.892007,717.469 Z"></path>
            </g>
        </g>
    </g>
</svg>
);

export const ListIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9">
    <path
      d="M16 7.5V9H0V7.5h16zM16 0v1.5H0V0h16z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.74812 0.0249993L5.51253 4.25L1.25188 0L0.5 0.75L4.76065 5L0.500001 9.25L1.25188 10L5.51253 5.75L9.74812 9.975L10.5 9.225L6.26441 5L10.5 0.774999L9.74812 0.0249993Z"
      fill="#2A312E"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg width="16" height="11" viewBox="0 0 16 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2715 8.85616C12.2469 8.94846 12.22 9.03842 12.1873 9.12838C11.8404 10.07 10.9572 10.7056 9.95479 10.7383C8.95236 10.7698 8.03058 10.1915 7.62283 9.27557C7.56208 9.14123 7.51418 9.00104 7.4803 8.85616L1.42019 8.85616C1.08956 8.85616 0.822017 8.58863 0.822017 8.25799C0.822017 7.92853 1.08955 7.65981 1.42019 7.65981L7.47671 7.65981C7.50124 7.56985 7.52811 7.47756 7.56083 7.3876C7.78981 6.7754 8.25597 6.28003 8.85298 6.01248C9.51892 5.71221 10.2842 5.72274 10.9419 6.04052C11.5997 6.3583 12.0834 6.95181 12.2621 7.65981L14.58 7.65981C14.9107 7.65981 15.1782 7.92851 15.1782 8.25799C15.1782 8.58862 14.9107 8.85616 14.58 8.85616L12.2715 8.85616ZM8.59829 8.30942C8.61465 8.82346 8.93943 9.27676 9.42078 9.45785C9.73739 9.57468 10.0879 9.5595 10.3928 9.4158C10.6989 9.28028 10.9396 9.02911 11.0599 8.71599C11.1125 8.57228 11.1405 8.42041 11.1405 8.26736C11.1405 7.83626 10.9209 7.43436 10.5587 7.2007C10.1954 6.96587 9.73972 6.93199 9.34601 7.10957C8.87751 7.32219 8.58193 7.79538 8.59829 8.30942ZM8.41608 3.32317C8.23617 4.0557 7.7303 4.66323 7.04332 4.97165C6.44748 5.24503 5.76728 5.26725 5.15508 5.03476C4.39686 4.75083 3.82788 4.11061 3.63628 3.32317L1.41998 3.32317C1.08935 3.32317 0.82181 3.05564 0.82181 2.725C0.82181 2.39553 1.08934 2.12682 1.41998 2.12682L3.63978 2.12682C3.89332 1.1104 4.76369 0.36502 5.80817 0.270386C6.85264 0.176921 7.8422 0.752904 8.27564 1.70858C8.33405 1.84409 8.38195 1.98429 8.41817 2.12682L14.58 2.12682C14.9106 2.12682 15.1781 2.39552 15.1781 2.725C15.1781 3.05563 14.9106 3.32317 14.58 3.32317L8.41608 3.32317ZM5.57711 3.91551L5.57828 3.91551L5.57714 3.92135C5.89375 4.03935 6.24425 4.02533 6.54917 3.88279C7.00481 3.676 7.29689 3.22271 7.29689 2.72266C7.29806 2.54273 7.25834 2.36516 7.18356 2.20159C7.0083 1.81487 6.65197 1.5415 6.23372 1.47257C5.81428 1.40249 5.38903 1.54734 5.09812 1.85695C4.80837 2.16657 4.69154 2.60117 4.78734 3.01475C4.8843 3.42833 5.17989 3.76597 5.57711 3.91551Z" fill="currentColor"/>
  </svg>
);

export const ListViewIcon = () => (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 8.72552H1.5V9.99998H0V8.72552Z" fill="currentColor"/>
      <path d="M0 4.36267H1.5V5.63712H0V4.36267Z" fill="currentColor"/>
      <path d="M0 0H1.5V1.27445H0V0Z" fill="currentColor"/>
      <path d="M3.29993 8.72552H13.2999V9.99998H3.29993V8.72552Z" fill="currentColor"/>
      <path d="M3.29993 4.36267H13.2999V5.63712H3.29993V4.36267Z" fill="currentColor"/>
      <path d="M3.29993 0H13.2999V1.27445H3.29993V0Z" fill="currentColor"/>
  </svg>
);

export const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1738 11.4812C14.3728 8.72083 14.2176 4.63392 11.7079 2.06043C10.4124 0.73196 8.68958 0 6.85709 0C5.02461 0 3.30169 0.731942 2.00629 2.06043C-0.668763 4.80352 -0.668763 9.26589 2.00629 12.009C3.30181 13.3382 5.02461 14.0694 6.85709 14.0694C8.45668 14.0694 9.97232 13.5118 11.1933 12.4868L14.4162 15.7917C14.551 15.9306 14.7291 16 14.9065 16C15.084 16 15.2614 15.9306 15.3968 15.7917C15.6677 15.5139 15.6677 15.0639 15.3968 14.7861L12.1738 11.4812ZM10.7272 11.0034C9.69313 12.0638 8.31899 12.6471 6.85699 12.6471C5.39498 12.6471 4.02088 12.0631 2.98674 11.0034C0.852773 8.81514 0.852773 5.2541 2.98674 3.06602C4.02084 2.00631 5.39498 1.42228 6.85699 1.42228C8.31899 1.42228 9.6931 2.00631 10.7272 3.06602C12.8612 5.25481 12.8612 8.81532 10.7272 11.0034Z" fill-rule="evenodd" clip-rule="evenodd" fill="#998152"/>
  </svg>
);